import ThirdPartyScripts from "./ThirdPartyScripts";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import AccountPage from "./pages/AccountPage";
import SSOLoginPage from "./pages/SSOLoginPage";

function App() {
  return (
    <>
      <ThirdPartyScripts />
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/sso-login" element={<SSOLoginPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;